export default __webpack_public_path__ + "static/media/x.8c823f6d.svg";